﻿document.addEventListener("DOMContentLoaded", function() {
    document.getElementById('currentYear').textContent = new Date().getFullYear();
});